import script from "./myMainPageNew.vue?vue&type=script&setup=true&lang=js"
export * from "./myMainPageNew.vue?vue&type=script&setup=true&lang=js"

import "./myMainPageNew.vue?vue&type=style&index=0&id=00fa75e4&scoped=true&lang=scss"

import exportComponent from "/Users/hooeni/Workspace/eduwind-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00fa75e4"]])

export default __exports__